import React, { Component } from 'react'
import { Row, Col, Card, CardBody, Alert, Modal, ModalBody, Button } from 'reactstrap'
import { bindActionCreators } from "redux";
import {
  ItemQuestion, ItemFeedback, ItemPassage,
  ItemBasicNav, ItemCircles, AssessSubmitModal,
  AssessDirectionsModal,
} from '../AssessTest'
import keys from 'mout/object/keys'
import queryString from 'query-string'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import getCorrectAnswer from '../../../helpers/assessment/getCorrectAnswer'
import createMarkup from '../../../helpers/createMarkup'
import * as assessmentActionCreators from "../../../redux/modules/assessment";
import { BeatLoader } from 'react-spinners'
import {
  ItemAnswers, CurrentQuestionAlert
} from './AssessTestComponents'
import ReactModal from "react-modal";
import {
  Transition
} from 'react-transition-group';
/* AssessTestTake:
  <AssessTestItemView
    activeItem={props.activeItem}
    selectAnswer={props.selectAnswer}
    selectedAnswer={props.selectedAnswer}
    itemNumber={props.itemNumber}
    nextItemLinkTo={`?item=${parseInt(props.itemNumber) + 1}`}
    completed={completed}
    handleSubmit={props.handleSubmitActivity}
    lastItemNumber={lastItemNumber}
    handleQuickNav={props.handleQuickNav}
    timeRemaining={props.timeRemaining}
    isGroup={props.isGroup}
    assessmentId={props.assessmentId}
    selectedStudent={props.selectedStudent}
    answersByItem={answersByItem}
  />
*/

// Question, Answer Choices (each of which can be selected), submit answer button, feedback, lock out if already completed
// itemQuestion props: active, choice, answer

/*
When completed:
  Display the work and the feedback
  Link to next item
  
  At all times:
  Arrows left and right to navigate to next and previous items
  Nav back to Assignments
  
  
  IF NEXTITEMLINKTO === '' THEN WE HAVE TO GO BACK TO THE ASSIGNMENT PAGE AS THE LINK...
  */
ReactModal.setAppElement('#root');
class AssessTestItemView extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
      itemChange: false,
      cardDirection : '',
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.handleChangeItem = this.handleChangeItem.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }
  
  componentDidMount() {
    window.addEventListener('keypress', this.handleKeyPress, false)
    window.addEventListener('keydown', this.handleKeyDown, false)
    this.props.loadAssessmentHeader();
  }



  handleKeyDown(e) {
    const { keyCode } = e
    const { itemNumber, lastItemNumber } = this.props
    switch (keyCode) {
      case 37:
        e.preventDefault()
        if (
          itemNumber &&
          Number(itemNumber) >= 2
        ) {
          this.handleChangeItem(Number(itemNumber) - 1, 'prev')
        }
        break
      case 39:
        e.preventDefault()
        if (
          itemNumber &&
          itemNumber != lastItemNumber
        ) {
          this.handleChangeItem(Number(itemNumber) + 1, 'next')
        }
        break
    }

  }

  handleKeyPress({ key }) {
    const { activeItem, selectAnswer, selectedAnswer, completed } = this.props
    const keypress = {
      a: 'answer0000',
      b: 'answer0001',
      c: 'answer0002',
      d: 'answer0003',
      e: 'answer0004',
      f: 'answer0000',
      g: 'answer0001',
      h: 'answer0002',
      j: 'answer0003',
      k: 'answer0004',
    }
    if (key && keypress[key] && !completed) {
      const selected = selectedAnswer === keypress[key]
      if (activeItem && activeItem.answers) {
        if (key === 'e' || key === 'k') {
          if (keys(activeItem.answers).length < 5) return
        }
        selectAnswer(selected ? '' : keypress[key])
      }
    }
  }



  componentWillUnmount() {
    window.removeEventListener('keypress', this.handleKeyPress, false)
    window.removeEventListener('keydown', this.handleKeyDown, false)
    this.props.unLoadAssessmentHeader()
  }

  toggleModal() {
    this.setState({ showModal: !this.state.showModal });
  }


  handleChangeItem(nextItem, nextOrPrev) {
    const { search, navTo } = this.props
    const { assessmentId, selectedGroupUA, selectedStudent } = this.props
    const g = selectedGroupUA ? 'g=true&' : ''
    const a = selectedGroupUA || selectedStudent ? `a=${assessmentId}&` : ''
    const s = (selectedStudent && `s=${selectedStudent}&`) || '';  
    this.props.navTo(`?${a}${g}${s}item=${Number(nextItem)}`);
    if (nextOrPrev === 'submit' && !this.props.licenseExpired) {
      const qs = queryString.parse(search)
      qs.m = 'submit'
      const newQuery = queryString.stringify(qs)
      return navTo(`?${newQuery}`)
    }

  }


  componentWillReceiveProps(nextProps) {
    this.props.itemNumber !== nextProps.itemNumber  && this.setState({itemChange : !this.state.currentItem, cardDirection : this.props.itemNumber < nextProps.itemNumber ? 'next' : 'prev' });
  }
  componentDidUpdate(prevProps){
     this.props.itemNumber !== prevProps.itemNumber && this.setState({itemChange : false});
  }

  render() {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    var isEdge = navigator.appVersion.indexOf('Edge') > -1
    const props = this.props
    let correctAnswer = ''
    if (/*props.completed && */!props.selectedAnswer && props.activeItem) {
      correctAnswer = getCorrectAnswer(props.activeItem.answers)
    }


    let itemPassage = null
    let passageNavItems = null
    let passageNav = null
    let itemViewCols = {
      xs: '12',
      md: '12'
    }
    if (props.activeItem && props.subtestName !== 'math') {
      if (props.activeItem.passageId || props.activeItem.passage) {
        let sectionBreaks = []
        if (props.userAssessment && props.userAssessment.assessmentSubtests[props.subtestId]) {
          sectionBreaks = props.userAssessment.assessmentSubtests[props.subtestId].sectionBreaks
        }
        let uAid = ''
        if (props.isGroup && !props.selectedStudent) {
          uAid = props.selectedGroupUA
        } else {
          props.userAssessment ? uAid = props.userAssessment.userAssessmentId : null
        }


       
        let prevPass, nextPass
        let addedQuery = ''
        if (props.isGroup) {
          addedQuery = `&g=true&a=${props.assessmentId}`
        }
        if (sectionBreaks) {
          
          if (Array.isArray(sectionBreaks) && sectionBreaks.length > 0) {
            passageNavItems = sectionBreaks.map((sectionBreak, n) => {
              let clName = ''
              if (sectionBreak <= parseInt(props.itemNumber) && (sectionBreaks[n + 1] > parseInt(props.itemNumber) || n + 1 === sectionBreaks.length)) {
                clName = 'current-passage'
                if (n > 0) {
                  prevPass = sectionBreaks[n - 1]
                }
                if (n < sectionBreaks.length - 1) {
                  nextPass = sectionBreaks[n + 1]
                }
              }
              return (
                <li
                  key={`sectionBreakAt${sectionBreak}`}
                  className={`passage-item ${clName}`}
                >
                  <Link to={`/assessment/testing/${uAid}/${props.subtestId}?item=${sectionBreak}${addedQuery}`}>
                    {n + 1}
                  </Link>
                </li>
              )
            })
          }
        }
      
          passageNav = (
            <div className='passage-nav'>
              Passage: 
              <ul className='passage-quick-nav'>
                {passageNavItems}
              </ul>

            </div>
          )
        
        itemPassage = (
            <ItemPassage
              passage={props.activeItem ? props.activeItem.passage : ''}
              sectionBreaks={sectionBreaks}
              subtestId={props.subtestId}
              uAid={uAid}
              itemChange={this.state.itemChange}
              itemNumber={props.itemNumber}
              itemChange={this.state.itemChange}
              assessmentId={props.assessmentId}
              isGroup={props.isGroup}
              fontValue={this.props.fontValue}
            />
        )
        itemViewCols.md = '5'
      }
    }

    let alert = null
    if (props.user) {
      if (
        (!props.answersByItem && props.user.role !== 'Student') ||
        (props.selectedStudent && !props.selectedAnswer)
      ) {
        let text = 'This student has not answered this item.'
        if (props.isGroup && !props.selectedStudent) {
          text = 'No selected students have answered this item.'
          if (!props.activeItem) {
            text = 'No selected students have completed this test.'
          }
        }
        alert = (
          <Alert color='warning'>
            {text}
          </Alert>
        )
      }
    }

    let directions = ''
    if (props.userAssessment && props.userAssessment.assessmentSubtests[props.subtestId]) {
      directions = props.userAssessment.assessmentSubtests[props.subtestId].directions
    }

    const customStyles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        color: "#62b6e8",
        backgroundColor: "rgb(216, 216, 216)"
      }
    };
    const spanStyle = {
      color: "#6e6e6e",
      float: "right",
      cursor: "pointer"
    };
    const divPaddingStyle = {
      paddingTop: "14px"
    };
    const qs = queryString.parse(this.props.search)

    const {
      itemNumber,
      lastItemNumber,
      isGroup,
      assessmentId,
      selectedStudent,
      completed,
      activeItem,
      selectedAnswer,
      answersByItem,
      user,
      selectAnswer,
      items,
      userAssessment,
      subtestId
    } = this.props
    const { handleChangeItem } = this


    const itemsAll = userAssessment && userAssessment.destructuredSubtests && userAssessment.destructuredSubtests[subtestId].items;
    const scoring_list = props.userAssessment && props.userAssessment.scoring && props.userAssessment.scoring.byItem  && props.userAssessment.scoring.byItem[subtestId];
    const item = itemsAll && items && items[itemsAll[Number(itemNumber)-1]];
   
    return (
      itemsAll && items ? <Row className={`assessment-container ${completed ? 'test-complete' : ''}`}>


       {!this.props.licenseExpired && <AssessSubmitModal
          handleSubmitSubtest={props.handleSubmitSubtest}
          isOpen={qs.m === 'submit'}
          navTo={props.navTo}
          search={props.search}
          user={props.user}
          activeItem={activeItem}
          answersByItem={userAssessment.answersByItem}
          userAssessment={props.userAssessment}
          groupUA={props.groupUA}
          selectedStudent={props.selectedStudent}
          subtestId={props.subtestId}
          itemNumber={props.itemNumber}
          completed={props.completed}
          isGroup={props.isGroup}
          selectedGroupUA={props.selectedGroupUA}
          items={props.items}
          assessmentId={assessmentId}
        />}
        
        <AssessDirectionsModal
          isOpen={qs.m === 'directions'}
          directions={directions}
          navTo={props.navTo}
          search={props.search}
        />
        <Col xs='12' xl='12'>
        {props.subtestName !== 'math' && passageNav}
          {(props.activeItem) &&
              <Row>      
                  <Col xs='12' md='7'  className={`item-passage-col ${props.subtestName === 'math' && 'order-2'}`}>
                  <div className='passage-container'>
                              {props.subtestName !== 'math' && itemPassage}
                              {props.activeItem && (props.subtestName !== 'math' ? window.innerWidth > 990 : true ) && <Col xs='12' md='12'>
                                    <Card className={`test-overview-nav ${props.subtestName === 'math' && window.innerWidth > 990 && 'mt-0'}`}>
                                      <div className="test-nav-header">
                                            Question Navigation:
                                            </div>
                                          <ItemCircles
                                            user={props.user}
                                            activeItem={activeItem}
                                            answersByItem={props.userAssessment.answersByItem}
                                            userAssessment={props.userAssessment}
                                            groupUA={props.groupUA}
                                            selectedStudent={props.selectedStudent}
                                            subtestId={props.subtestId}
                                            itemNumber={props.itemNumber}
                                            completed={props.completed}
                                            isGroup={props.isGroup}
                                            selectedGroupUA={props.selectedGroupUA}
                                            items={props.items}
                                            assessmentId={assessmentId}
                                          />
                                      </Card>
                                </Col> }
                         </div>
                          </Col>
              

                <Col xs='12' md={5}>
                  <div className='questions-container non-math'>

                    <Col>

                      
                          <div>    
                            <Card className={`question non-math`}>
                              <div className="prev-nav-link">
                                <ItemBasicNav
                                  itemNumber={Number(itemNumber)}
                                  lastItemNumber={lastItemNumber}
                                  isGroup={isGroup}
                                  assessmentId={assessmentId}
                                  selectedStudent={selectedStudent}
                                  completed={completed}
                                  handleChangeItem={handleChangeItem}
                                  licenseExpired={this.props.licenseExpired}
                                />
                              </div>
                              <Transition
                                    in={!this.state.itemChange}
                                    timeout={300}
                                    >
                            {state => (
                             
                              <CardBody className={`question-${this.state.cardDirection}-${state}`}>
                              { state === 'entered' ? <React.Fragment>
                                <CurrentQuestionAlert
                                  answersByItem={answersByItem}
                                  user={user}
                                  selectedStudent={selectedStudent}
                                  selectedAnswer={selectedAnswer}
                                  isGroup={isGroup}
                                  activeItem={item}
                                />
                                <ItemQuestion fontValue={this.props.fontValue} question={item ? item.question : null} />
                                {item &&
                                  <ItemAnswers
                                    fontValue={this.props.fontValue}
                                    activeItem={item}
                                    isGroup={isGroup}
                                    answersByItem={answersByItem}
                                    selectedAnswer={selectedAnswer}
                                    selectAnswer={selectAnswer}
                                    completed={completed}
                                    scoring = {scoring_list}
                                  />
                                }
                                {item &&
                                  <ItemFeedback
                                    feedback={selectedAnswer ? item.answers[selectedAnswer].feedback : item.answers[correctAnswer].feedback}
                                    completed={completed}
                                    videoFeedback={item.videoFeedback}
                                    videoFeedbackThumbnail={item.videoFeedbackThumbnail}
                                    toggleModal={this.toggleModal}
                                  />
                                }
                              </React.Fragment>  : <BeatLoader className='loader-margin'  color={"#00C1AB"} loading={true} />}
                              </CardBody> )}
                              </Transition>
                            </Card>


                          </div>

                      
                    </Col>
                  </div>


                </Col>
              </Row>
            }
            {!props.activeItem &&
              <Row><Col><BeatLoader className='loader-margin'  loading={true}  color={"#00C1AB"} /></Col></Row>
            }
          {this.props.answerSelectedExpired &&
            <Modal
              isOpen={this.props.answerSelectedExpired}
              toggle={this.props.toggleAnswerExpired}
            >

              <ModalBody>Your license is expired, you cannot answer this item.</ModalBody>
              <Button color="secondary" onClick={this.props.toggleAnswerExpired}>Ok</Button>
            </Modal >

          }
          
        </Col>
        {props.activeItem  && props.subtestName !== 'math' &&  window.innerWidth < 990 && <Col xs='12' md='12'>
                                    <Card className='test-overview-nav'>
                                      <div className="test-nav-header">
                                            Question Navigation:
                                            </div>
                                          <ItemCircles
                                            user={props.user}
                                            activeItem={activeItem}
                                            answersByItem={props.userAssessment.answersByItem}
                                            userAssessment={props.userAssessment}
                                            groupUA={props.groupUA}
                                            selectedStudent={props.selectedStudent}
                                            subtestId={props.subtestId}
                                            itemNumber={props.itemNumber}
                                            completed={props.completed}
                                            isGroup={props.isGroup}
                                            selectedGroupUA={props.selectedGroupUA}
                                            items={props.items}
                                            assessmentId={assessmentId}
                                          />
                                      </Card>
                                </Col> }


          {activeItem && activeItem.videoFeedback && <div>
            <ReactModal
              isOpen={this.state.showModal}
              contentLabel="Video Feedback"
              style={customStyles}
              shouldCloseOnEsc={true}
              onRequestClose={this.toggleModal}
            >

              <div className="modal-video" dangerouslySetInnerHTML={createMarkup(activeItem.videoFeedback)}></div>
              <div style={divPaddingStyle}>
                <span onClick={this.toggleModal} style={spanStyle} >
                  Close
                                </span>
              </div>
            </ReactModal>
            
          </div>}
        
      </Row> : alert
    )
  }
}



export default connect(
  (state) => ({
    items: state.assessment.items,
    fontValue: state.assessment.fontValue,
    userLicenses : state.licenses.userlicenses
  }),
  dispatch =>
    bindActionCreators(
      { ...assessmentActionCreators},
      dispatch
    )
)(AssessTestItemView)


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/AssessTestItemView.js